/**
 * Register new module and init it
 * Modules are useful for one-time loading, eg. when page is loaded
 * Do not use them for components that can be included in modals, or are initialized multiple times!
 * @alias Ptx.module.register
 */
export function registerModule(name, init_fn) {
	console.log('Registering module ' +name);
	
	if (typeof init_fn == 'function') {
		init_fn();
	}
}
